module.exports = __webpack_public_path__ + "img/check-rounded-grey.c2f8224c.svg";